// we will use session storage to store the customer's decision to add/remove delivery protection
export const setOptOut = () => localStorage.setItem('WORRY_FREE_DELIVER', 'false')
export const setOptIn = () => localStorage.setItem('WORRY_FREE_DELIVER', 'true')
export const clearCustomerOptOut = () => localStorage.removeItem('WORRY_FREE_DELIVER')
export const customerOptedOutOfWFD = () => localStorage.getItem('WORRY_FREE_DELIVER') === 'false'
